import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MobileMainMenuComponent} from './mobile-main-menu/mobile-main-menu.component';
import {MobileNewRequestComponent} from './mobile-new-request/mobile-new-request.component';
import {NewRequestConfirmationComponent} from './new-request-confirmation/new-request-confirmation.component';
import {MobileOfferComponent} from './mobile-offer/mobile-offer.component';
import {MobileRequestInfoComponent} from './mobile-request-info/mobile-request-info.component';
import {routes} from './mobile-application-routes';
import {MainNavBarModule} from '../../Elements/main-nav-bar/main-nav-bar.module';
import {FormListGeneratorModule} from '../../Elements/form-list-generator/form-list-generator.module';
import {CustomButtonModule} from '../../Elements/custom-button/custom-button.module';
import {DetailsDivModule} from '../../Elements/details-div/details-div.module';
import {FinanceInvoiceDivModule} from '../../Elements/finance-invoice-div/finance-invoice-div.module';
import {FileUploadDivModule} from '../../Elements/file-upload-div/file-upload-div.module';
import {FormModule} from '../../Elements/form/form.module';
import { MobileTokenPageComponent } from './mobile-token-page/mobile-token-page.component';
import { MobileGuestStatusComponent } from './mobile-guest-status/mobile-guest-status.component';

@NgModule({
  declarations: [
    MobileMainMenuComponent,
    MobileNewRequestComponent,
    NewRequestConfirmationComponent,
    MobileOfferComponent,
    MobileRequestInfoComponent,
    MobileTokenPageComponent,
    MobileGuestStatusComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    ReactiveFormsModule,
    MainNavBarModule,
    FormListGeneratorModule,
    CustomButtonModule,
    DetailsDivModule,
    FinanceInvoiceDivModule,
    FileUploadDivModule,
    FormModule
  ]
})
export class MobileApplicationModule {
}
